import { api, endpoints } from "api/api";
import { AxiosPromise } from "axios";
import { BaseApiPaging } from "./types";
import { ExamFormValues } from "pages/Exams/Create/ExamForm";
import { Question, QuestionOptionType } from "survey";

const fetch = (
  skip: number,
  take: number,
  filter: string = "",
  orderBy: string = "",
): AxiosPromise<BaseApiPaging<ExamApi>> => {
  return api.get<BaseApiPaging<ExamApi>>(endpoints.EXAMS.GET(skip, take, filter, orderBy));
};

const fetchById = (id: number): AxiosPromise<ExamApi> => {
  return api.get<ExamApi>(endpoints.EXAMS.GET_BY_ID(id));
};

const create = (data: ExamFormValues): AxiosPromise<number> => {
  return api.post<number>(endpoints.EXAMS.CREATE(), data);
};

const duplicate = (id: number): AxiosPromise<number> => {
  return api.post<number>(endpoints.EXAMS.DUPLICATE(id));
};
const update = (id: number, data: ExamFormValues): AxiosPromise<void> => {
  return api.put<void>(endpoints.EXAMS.UPDATE(id), data);
};

const deleteSurvey = (id: number): Promise<void> => {
  return api.delete(endpoints.EXAMS.DELETE(id));
};

const updateQuestion = async (examId: number, questionId: number, data: Question): AxiosPromise<void> => {
  return api.put<void>(endpoints.EXAMS.UPDATE_QUESTION(examId, questionId), data);
};

const createQuestion = async (examId: number, data: Question): AxiosPromise<number> => {
  return api.post<number>(endpoints.EXAMS.CREATE_QUESTION(examId), data);
};

const deleteQuestion = async (examId: number, questionId: number): AxiosPromise<void> => {
  return api.delete<void>(endpoints.EXAMS.DELETE_QUESTION(examId, questionId));
};

export const examsApi = {
  fetch,
  fetchById,
  update,
  create,
  delete: deleteSurvey,
  updateQuestion,
  createQuestion,
  deleteQuestion,
  duplicate,
};

export interface ExamApi {
  id: number;
  name: string;
  description: string;
  isSystem: boolean;
  questions: ExamQuestionApi[];
}
export interface ExamQuestionApi {
  id: number;
  question: string;
  description: string;
  placeholder: string;
  textType: string;
  inputType: QuestionOptionType;
  questionOptionType: string;
  lowerLabel: string;
  upperLabel: string;
  required: boolean;
  sortOrder: number;
  options: { id: string; value: string }[];
}
